<template>
    <div id="nav" :class="['container-fluid', { 'scrolled': isScrolled }]">
        <div class="d-flex justify-content-between h-100">
            <div class="d-flex align-items-center">
                <a href="/">
                    <img class="logo" src="/images/logo.svg" />
                </a>
            </div>
            <div v-show="showNav" ref="mainNav" class="nav-main container-fluid">
                <div class="d-flex mt-3 justify-content-between align-items-center spans">
                    <div v-if="!activeMenu" class="text-start menu-title">
                        MENU
                    </div>

                    <div v-if="activeMenu" class="clickable text-start"  @click="goBackToMainMenu">
                        <component :is="ChevronBack" class="chevron" />
                        <span class="underline">
                            Terug
                        </span>
                    </div>

                    <div class="col text-end">
                        <div class="d-flex align-items-center justify-content-end clickable" @click="showNavigation">
                            <span class="ms-2 underline">
                                Sluiten
                            </span>
                            <component :is="CloseIcon" id="close" />
                        </div>
                    </div>
                </div>

                <!-- Add topbar similar to FilterBar -->
                <div v-if="activeMenu"  class="row mt-4 justify-content-center">
                    <div class="col-9">
                        <div class="topbar">
                            <div class="text-start border-bottom">
                                <div class="menu-subtitle">
                                    {{ getActiveMenuTitle() }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Main menu items -->
                <div v-if="show && !activeMenu">
                    <div class="row mt-4">
                        <div class="col">
                            <TextInput
                                ref="searchInput"
                                v-model="searchString"
                                type="text"
                                placeholder="Zoeken..."
                                @update:modelValue="handleSearchInput"
                                @keyup.enter="search">
                                <template #icon-right>
                                    <component :is="SearchIcon" class="search-icon" />
                                </template>
                            </TextInput>
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-9 text-start">
                            <div class="menu-item-main" @click="setActiveMenu('assortiment')">
                                <span class="menu-link">
                                    ASSORTIMENT
                                </span>
                                <component :is="ChevronForward" class="chevron-forward" />
                            </div>
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-9 text-start">
                            <div class="menu-item-main" @click="navigateTo('Actions')">
                                <span class="menu-link">
                                    ACTIES
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-9 text-start">
                            <div class="menu-item-main" @click="setActiveMenu('account')">
                                <span class="menu-link">
                                    ACCOUNT
                                </span>
                                <component :is="ChevronForward" class="chevron-forward" />
                            </div>
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-9 text-start">
                            <div class="menu-item-main" @click="setActiveMenu('wines')">
                                <span class="menu-link">
                                    MIJN WIJNEN
                                </span>
                                <component :is="ChevronForward" class="chevron-forward" />
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Submenu items -->
                <div v-if="show && activeMenu === 'assortiment'" class="submenu-container">
                    <!-- Top items (outsideContainer at top) -->
                    <div v-for="item in assortMenu.filter((item: MenuItem) => item.outsideContainer && item.label === 'ALLE WIJNLANDEN')" :key="item.label" class="row justify-content-center">
                        <div class="col-9 text-start">
                            <div class="menu-item-sub outside-container-item border-bottom" @click="item.callBack">
                                {{ item.label }}
                            </div>
                        </div>
                    </div>
                    
                    <!-- Scrollable countries section -->
                    <div class="countries-scroll-container">
                        <div v-for="item in assortMenu.filter((item: MenuItem) => !item.outsideContainer)" :key="item.label" class="row justify-content-center">
                            <div class="col-9 text-start">
                                <div class="menu-item-sub" @click="item.callBack">
                                    {{ item.label }}
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Bottom items (outsideContainer at bottom) -->
                    <div v-for="item in assortMenu.filter((item: MenuItem) => item.outsideContainer && item.label !== 'ALLE WIJNLANDEN')" :key="item.label" class="row justify-content-center">
                        <div class="col-9 text-start">
                            <div class="menu-item-sub outside-container-item" :class="{ 'border-top': item.borderTop }" @click="item.callBack">
                                {{ item.label }}
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="show && activeMenu === 'account'" class="submenu-container">
                    <div v-for="item in accountMenu" :key="item.label" class="row justify-content-center">
                        <div class="col-9 text-start">
                            <div class="menu-item-sub" @click="item.callBack">
                                {{ item.label }}
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="show && activeMenu === 'wines'" class="submenu-container">
                    <div v-for="item in wineMenu" :key="item.label" class="row justify-content-center">
                        <div class="col-9 text-start">
                            <div class="menu-item-sub" @click="item.callBack">
                                {{ item.label }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <ul class="list-inline h-100">
                    <NavItem v-if="show"
                             :img="cartCount >= 1 ? 'winkelmand_filled' : 'winkelmand_empty'"
                             label=""
                             :count="cartCount"
                             @click="navigateTo('Cart')" />

                    <NavItem v-if="show"
                             class="hamburger"
                             label="MENU"
                             design="hamburger"
                             @navClick="showNavigation" />
                </ul>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {
    computed, defineComponent, onMounted, onUnmounted, ref,
} from 'vue';
import { useRouter } from 'vue-router';
import ChevronBack from '@/assets/icons/chevron-back-outline.svg';
import ChevronForward from '@/assets/icons/chevron-forward.svg';
import CloseIcon from '@/assets/icons/close-outline.svg';
import SearchIcon from '@/assets/icons/search-outline.svg';
import NavItem from '@/components/NavItem.vue';
import NavItemMobile from '@/components/NavItemMobile.vue';
import BaseButton from '@/shared/components/BaseButton.vue';
import TextInput from '@/shared/components/form/TextInput.vue';

import {
    useAuthStore, useModalStore, useCartStore, useUIStore, 
} from '@/stores';

interface MenuItem {
    label: string;
    callBack: () => void;
    outsideContainer?: boolean;
    nodot?: boolean;
    logo?: string;
    borderTop?: boolean;
}

export default defineComponent({
    components: {
        TextInput,
        BaseButton,
        NavItemMobile,
        NavItem,
    },
    props: {
        show: {
            type: Boolean,
        },
    },
    setup() {
        const searchInput: any = ref(null);
        const authStore = useAuthStore();
        const modalStore = useModalStore();
        const cartStore = useCartStore();
        const uiStore = useUIStore();
        const router = useRouter();
        const active = ref('');
        const searchString = ref('');

        const showNav = ref(false);
        const cartCount = computed(() => cartStore.cartCount);
        const isScrolled = computed(() => uiStore.getIsScrolled);

        const activeMenu = ref('');

        function showNavigation() {
            showNav.value = !showNav.value;
            modalStore.toggleNavMobile();
        }

        function logout() {
            showNavigation();
            authStore.logout().then(() => router.push({ name: 'Login' }));
        }

        function navigateTo(url: string, query?: any) {
            if (showNav.value) {
                showNavigation();
            }

            window.scrollTo(0, 0);
            router.push({ name: url, query });
        }

        const assortMenu: MenuItem[] = [
            {
                label: 'ALLE WIJNLANDEN',
                callBack: () => navigateTo('Assortiment'),
                outsideContainer: true,
            },
            {
                label: 'Frankrijk',
                callBack: () => navigateTo('Assortiment', { land: 'frankrijk' }),
            },
            {
                label: 'Portugal',
                callBack: () => navigateTo('Assortiment', { land: 'portugal' }),
            },
            {
                label: 'Spanje',
                callBack: () => navigateTo('Assortiment', { land: 'spanje' }),
            },
            {
                label: 'Italië',
                callBack: () => navigateTo('Assortiment', { land: 'italië' }),
            },
            {
                label: 'Luxemburg',
                callBack: () => navigateTo('Assortiment', { land: 'luxemburg' }),
            },
            {
                label: 'Duitsland',
                callBack: () => navigateTo('Assortiment', { land: 'duitsland' }),
            },
            {
                label: 'Oostenrijk',
                callBack: () => navigateTo('Assortiment', { land: 'oostenrijk' }),
            },
            {
                label: 'Verenigde Staten',
                callBack: () => navigateTo('Assortiment', { land: 'verenigde staten' }),
            },
            {
                label: 'Chili',
                callBack: () => navigateTo('Assortiment', { land: 'chili' }),
            },
            {
                label: 'Argentinië',
                callBack: () => navigateTo('Assortiment', { land: 'argentinië' }),
            },
            {
                label: 'Nieuw-Zeeland',
                callBack: () => navigateTo('Assortiment', { land: 'nieuw-zeeland' }),
            },
            {
                label: 'Australië',
                callBack: () => navigateTo('Assortiment', { land: 'australië' }),
            },
            {
                label: 'Zuid-Afrika',
                callBack: () => navigateTo('Assortiment', { land: 'zuid-afrika' }),
            },
            {
                label: 'WIJNSTOPPER',
                callBack: () => navigateTo('Stoppers'),
                nodot: true,
                borderTop: true,
                outsideContainer: true,
            },
            {
                label: 'ZALTO GLAS',
                callBack: () => navigateTo('Zalto'),
                nodot: true,
                outsideContainer: true,
            },
        ];

        const accountMenu = [
            {
                logo: 'person-outline',
                label: 'Accountoverzicht',
                callBack: () => navigateTo('Account'),
                nodot: true,
            },
            {
                logo: 'bag-outline',
                label: 'Bestellingen',
                callBack: () => navigateTo('Orders'),
                nodot: true,
            },
            {
                logo: 'receipt-outline',
                label: 'Facturen',
                callBack: () => navigateTo('Invoices'),
                nodot: true,
            },
            {
                logo: 'exit-outline',
                label: 'Uitloggen',
                callBack: logout,
                nodot: true,
            },
        ];

        const wineMenu = [
            {
                logo: 'repeat-outline',
                label: 'Eerder besteld',
                callBack: () => navigateTo('OrderedBefore'),
                nodot: true,
            },
            {
                logo: 'heart-outline',
                label: 'Favorieten',
                callBack: () => navigateTo('Favorites'),
                nodot: true,
            },
        ];

        function callback(val: any) {
            if (val.callBack) {
                val.callBack();
            }
        }

        function handleSearchInput(value: string) {
            searchString.value = value;
        }

        function search() {
            if (searchString.value.trim()) {
                showNavigation(); // Close the nav menu
                modalStore.setSearch(searchString.value);
                navigateTo('Assortiment', { search: searchString.value });
                modalStore.doSearch();
            }
        }

        function setActiveMenu(menu: string) {
            activeMenu.value = menu;
        }

        function goBackToMainMenu() {
            activeMenu.value = '';
        }

        function getActiveMenuTitle() {
            if (activeMenu.value === 'assortiment') {
                return 'ASSORTIMENT';
            }

            if (activeMenu.value === 'account') {
                return 'ACCOUNT';
            }

            if (activeMenu.value === 'wines') {
                return 'MIJN WIJNEN';
            }
            return 'MENU';
        }

        const width = ref(window.innerWidth);
        const onWidthChange = () => width.value = window.innerWidth;

        onMounted(() => {
            window.addEventListener('resize', onWidthChange);
            uiStore.initScrollListener();
        });

        onUnmounted(() => {
            window.removeEventListener('resize', onWidthChange);
            uiStore.removeScrollListener();
        });

        const mainNav = ref(null);

        return {
            accountMenu,
            wineMenu,
            assortMenu,
            showAccount: ref(false),
            showOther: ref(false),
            callback,
            handleSearchInput,
            search,
            width,
            showNavigation,
            mainNav,
            showNav,
            active,
            navigateTo,
            CloseIcon,
            SearchIcon,
            ChevronBack,
            ChevronForward,
            searchString,
            cartCount,
            searchInput,
            isScrolled,
            activeMenu,
            setActiveMenu,
            goBackToMainMenu,
            getActiveMenuTitle,
        };
    },
});
</script>

<style scoped lang="scss">
@import "~@/assets/variables";

.spans {
    span {
        font-family: "DINPro-regular", sans-serif;
        font-weight: 400;
        font-stretch: semi-condensed;
        font-size: 1rem;
        color: $black;
    }
}
.chevron {
    width: 24px;
}

#close {
    width: 2.1rem;
}

.search-icon {
    height: 1rem;
    margin-left: 1rem;
    color: #969696;
}

#nav {
    height: 100px;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    box-shadow: 0px 0px 10px 0px #D9D9D9;
    background: white;
    transition: height 0.3s ease;

    &.scrolled {
        height: 70px;
    }
}

* {
    user-select: none;
}

.logo {
    height: 45px;
    margin: 1.25rem 0;
    transition: height 0.3s ease, margin 0.3s ease;

    #nav.scrolled & {
        height: 35px;
        margin: 1rem 0;
    }
}

button {
    width: 108px;
    height: 36px;
    margin: 0 10px;
    border: none;
}

;

.nav-main {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    flex: none;
    z-index: 15;
    background: $white;
    border: 1.25rem solid $kwast-red;
    overflow: hidden;

    padding: 30px;

    font-family: "DINPro", sans-serif;

    #close {
        font-weight: 400;
        font-size: 2.1rem;
        cursor: pointer;
    }
}

.modal-backdrop {
    background: $white;

    &.show {
        opacity: .95;
    }
}

.assortment {
    max-height: 23rem;
}

.topbar {
    padding: 0.5rem 0;
}

.menu-title {
    font-size: 1.5rem;
    font-weight: 500;
    font-stretch: semi-condensed;
}

.menu-subtitle {
    font-family: "DINPro", sans-serif;
    font-weight: 500;
    font-stretch: semi-condensed;
    font-size: 24px;
    line-height: 26.08px;
    letter-spacing: 1px;
    text-transform: uppercase;
    padding-bottom: 15px;
}

.menu-item-main {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.75rem 0;
    cursor: pointer;
}

.menu-link {
    font-size: 1rem;
    color: $black;
    font-weight: bold;
    text-decoration: none;

    font-family: "DINPro", sans-serif;
    font-weight: 500;
    font-stretch: semi-condensed;
    font-size: 22px;
    line-height: 26.08px;
    letter-spacing: 1px;
    text-transform: uppercase;
}

.chevron-forward {
    width: 1.5rem;
    height: 1.5rem;
}

.submenu-container {
    // padding: 0 1.5rem;
    max-height: 60vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.countries-scroll-container {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    max-height: calc(60vh - 120px); /* Account for top and bottom items */
    // style scrollbar
    &::-webkit-scrollbar {
        width: 3px;
    }
    &::-webkit-scrollbar-thumb {
        background: $kwast-red;
    }
}

.menu-item-sub {
    font-weight: 300;
    font-size: 18px;
    color: $black;
    padding: 0.75rem 0;
    cursor: pointer;
    font-family: "DINPro-regular", sans-serif;
    font-weight: 300;
    font-stretch: semi-condensed;
    letter-spacing: 1px;
}

.outside-container-item {
//
}

.reset-modal {
    font-size: 14px;
    cursor: pointer;
    font-family: "DINPro", sans-serif;
    font-weight: 400;
    text-decoration: underline;
    letter-spacing: 0;
    color: $black;
    display: flex;
    align-items: center;
    gap: 0;

    &:hover {
        text-decoration: underline;
    }
}
</style>
